<template>
  <event-form>
    <ButtonCreate class="mt_m"/>
    <ButtonCreateAutoEntry class="mt_m"/>
  </event-form>
</template>

<script>
import EventForm from '@/components/Event/Form'
import ButtonCreate from '@/components/Event/ButtonCreate'
import ButtonCreateAutoEntry from '@/components/Event/ButtonCreateAutoEntry'

export default {
  components: {
    EventForm,
    ButtonCreate,
    ButtonCreateAutoEntry,
  },
  created: async function () {
    this.$store.dispatch('event/resetForm')
  }
}
</script>
